import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import type { Product } from '../types/product.type';

export const GetProductSchema = z.object({
  product_id: z.string().min(1, {
    message: 'id produk tidak boleh kosong!',
  }),
});
export type GetProductPayload = z.infer<typeof GetProductSchema>;
export type GetProductResponse = ApiResponse<Product>;

export const getProduct = async (
  payload: GetProductPayload
): Promise<GetProductResponse> => {
  const { product_id } = payload;
  const url = `product/${product_id}`;

  return await apiClient.get(url);
};

export const GET_PRODUCT_QUERY_KEY = 'product';
export function getProductQueryOptions(payload: GetProductPayload) {
  return queryOptions({
    queryKey: [GET_PRODUCT_QUERY_KEY, payload.product_id],
    queryFn: () => getProduct(payload),
  });
}
